module.exports = __webpack_public_path__ + "static/sylwiawork3-a6e4c0192702e60a1b25589f150e5419.jpg";